import React from 'react';
import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
    handle_Authenticate, 
    handle_signedIn, 
    handle_auth_user, 
} from '../../Redux/reducer';
import {
    handleSignUp,
} from '../../Redux/actions';

//DB
import fire from '../../Firebase/fire';

export const SignUp = () => {
  
  const isSignedIn = useSelector((state) => state.auth.isSignedIn);
  const dispatch = useDispatch();

  // References
  const usernameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();

  

  //SignUp Final Function
  const handleSignUpSubmit = (e) => {
    e.preventDefault();
    const user = {
      userName: usernameRef.current.value,
      email: emailRef.current.value,
      password: passwordRef.current.value,
    };
    if (
      usernameRef.current.value == "" ||
      emailRef.current.value == "" ||
      passwordRef.current.value == ""
    ) {
        // console.log("SignUp:handleSignUpSubmit: Please fill all the fields");
        window.alert("Please fill all the fields to sign up")
    } else {
        // console.log("SignUp:handleSignUpSubmit:user = ",user);
        dispatch(handleSignUp(user));
    }
  };
  //SignUp on enter-press
  const enterSignUpPressed = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      handleSignUpSubmit(event);
      //13 is the enter keycode
      //Do stuff in here
    }
  };

    return(
        <div>
            <div className='home-contact-join-form-title'>
                Join us
              </div>
              <form onSubmit={handleSignUpSubmit} onKeyPress={enterSignUpPressed}>
                <input 
                    className='username-ip' 
                    placeholder="Username"
                    type="text"
                    required
                    ref={usernameRef}
                /><br></br>
                <input 
                    className='email2-ip' 
                    placeholder="E-mail" 
                    type="email"
                    required
                    ref={emailRef}
                /><br></br>
                <input 
                    className='pswd-ip' 
                    placeholder="Password" 
                    type="password"
                    required
                    ref={passwordRef}
                /><br></br>
                <button className='home-contact-join-submit-btn' type={"submit"}>Sign Up</button>
              </form>
              <div className='home-contact-signup'>
                Are you a member? 
                <a className='home-contact-signup-link' 
                    onClick={()=>dispatch(handle_signedIn(true))}
                > Sign In </a> 
                again
              </div>
        </div>
    )
}

export default SignUp;